module.exports = __webpack_public_path__ + "static/media/favicon.0725e910.ico";